import React from "react";
import {
  TextInput,
  SimpleForm,
  required,
  useRedirect,
  useRefresh,
  ReferenceInput,
  SelectInput,
  CreateProps,
} from "react-admin";
import { GetParam } from "utils/tools";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomCreateToolbar from "components/CustomCreateToolbar";
import AddressAutoCompleteInput from "components/AddressAutoCompleteInput";
import CreateWrapper from "../../components/CreateWrapper";

const AddressCreate = (props: CreateProps) => {
  const param = GetParam();
  const redirect = useRedirect();
  const refresh = useRefresh();

  let breadcrumbValue = [{ link: "", title: "", params: "" }];

  if (param.get("parentId")) {
    breadcrumbValue = [
      {
        title: "Parents",
        link: `/parents/${param.get("parentId")}/show`,
        params: "",
      },
      {
        title: "Students",
        link: `/students/${param.get("studentId")}/show`,
        params: `?parentId=${param.get("parentId")}`,
      },
      {
        title: "Address",
        link: `/students/${param.get("studentId")}/show/3`,
        params: `?parentId=${param.get("parentId")}`,
      },
      {
        title: "Create",
        link: "",
        params: "",
      },
    ];
  } else {
    breadcrumbValue = [
      {
        title: "Students",
        link: `/students/${param.get("studentId")}/show`,
        params: "",
      },
      {
        title: "Address",
        link: `/students/${param.get("studentId")}/show/3`,
        params: "",
      },
      {
        title: "Create",
        link: "",
        params: "",
      },
    ];
  }

  const breadcrumb = breadcrumbValue;

  const CustomRedirect = (props: { data: IStudentAddress }) => {
    redirect(`/students/${props.data.studentId}/show/3`);
    refresh();
  };

  const transform = async (data: any) => {
    data.lat = data.locationData.LATITUDE;
    data.lng = data.locationData.LONGITUDE;
    data.isFromSchool = false;
    data.isToSchool = false;
    data.isMain = false;

    delete data.wayType;
    delete data.locationData;

    return data;
  };

  return (
    <>
      <CreateWrapper
        breadcrumb={breadcrumb}
        headerTitle="New Address"
        transform={transform}
        onSuccess={CustomRedirect}
        {...props}
      >
        <SimpleForm toolbar={<CustomCreateToolbar />}>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Student</Typography>
            </Grid>
            <Grid item xs={3}>
              <ReferenceInput
                label="Select Student"
                source="studentId"
                reference="students"
                disabled
              >
                <SelectInput
                  optionText={(choice: any) =>
                    `${choice.firstName} ${choice.lastName}`
                  }
                />
              </ReferenceInput>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Details</Typography>
            </Grid>
            <Grid item xs={2}>
              <AddressAutoCompleteInput
                label="Postal Code"
                source="postalCode"
                referenceSource="locationData"
              />
            </Grid>
            <Grid item xs={10}></Grid>

            <Grid item xs={2}>
              <TextInput label="Unit No." source="unitNumber" />
            </Grid>
            <Grid item xs={2}>
              <TextInput label="Block No." source="blockNumber" />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <TextInput label="Building Name" source="building" />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <TextInput label="Street" source="street" validate={required()} />
            </Grid>
            <Grid item xs={8}></Grid>
          </SanitizedGrid>
        </SimpleForm>
      </CreateWrapper>
    </>
  );
};

export default AddressCreate;
